module.exports = {"500233001":"忠州街道","500233002":"白公街道","500233003":"乌杨街道","500233004":"新生街道","500233102":"任家镇","500233104":"洋渡镇","500233105":"东溪镇","500233106":"复兴镇","500233107":"石宝镇","500233108":"汝溪镇","500233109":"野鹤镇","500233110":"官坝镇","500233111":"石黄镇","500233112":"马灌镇","500233113":"金鸡镇","500233114":"新立镇","500233115":"双桂镇","500233116":"拔山镇","500233117":"花桥镇","500233118":"永丰镇","500233119":"三汇镇","500233120":"白石镇","500233122":"黄金镇","500233201":"善广乡","500233203":"石子乡","500233204":"磨子土家族乡","500233206":"涂井乡","500233208":"金声乡","500233210":"兴峰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500233.json
// module id = 2243
// module chunks = 0